import { useState } from 'react';
import { Box, Image, Flex } from '@chakra-ui/react';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import style from './Carousel.module.css';
import classNames from 'classnames';
type Image = string | File;
interface Props {
  images: Image[];
  onRemove?: (file: Image) => void;
}
export const Carousel = ({
  images,
  onRemove
}: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const handleNext = () => {
    setCurrentIndex(prevIndex => prevIndex + 1 === images.length ? 0 : prevIndex + 1);
  };
  const handlePrevious = () => {
    setCurrentIndex(prevIndex => prevIndex - 1 < 0 ? images.length - 1 : prevIndex - 1);
  };
  const handleDotClick = (index: number) => {
    setCurrentIndex(index);
  };
  const handleRemove = () => {
    if (onRemove && images[currentIndex]) {
      onRemove(images[currentIndex]);
      if (currentIndex === images.length - 1) {
        setCurrentIndex(currentIndex - 1);
      }
    }
  };
  const currentImage = images[currentIndex];
  const imageUrl = currentImage instanceof File ? URL.createObjectURL(currentImage) : currentImage;
  const hasMultipleImages = images.length > 1;
  const carouselImagesClasses = hasMultipleImages ? [style.carouselImages, style.multipleImages] : [style.carouselImages];
  return <Box className={style.carousel} data-sentry-element="Box" data-sentry-component="Carousel" data-sentry-source-file="Carousel.tsx">
      <Flex gap="16px" data-sentry-element="Flex" data-sentry-source-file="Carousel.tsx">
        {hasMultipleImages && <Flex align="center" justify="center" onClick={handlePrevious} cursor="pointer">
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
              <path d="M400 976 0 576l400-400 56 57-343 343 343 343-56 57Z" />
            </svg>
          </Flex>}
        <Box className={classNames(carouselImagesClasses)} data-sentry-element="Box" data-sentry-source-file="Carousel.tsx">
          <Image key={currentIndex} objectFit="contain" src={imageUrl} alt="" borderRadius="md" data-sentry-element="Image" data-sentry-source-file="Carousel.tsx" />
        </Box>
        {hasMultipleImages && <Flex align="center" justify="center" onClick={handleNext} cursor="pointer">
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
              <path d="m304 974-56-57 343-343-343-343 56-57 400 400-400 400Z" />
            </svg>
          </Flex>}
      </Flex>
      {hasMultipleImages && <Flex className={style.carouselIndicator} justify="center" mt="2">
          {images.map((_, index) => <Box key={index} className={`${style.dot} ${currentIndex === index ? style.active : ''}`} onClick={() => handleDotClick(index)} w="4" h="4" borderRadius="full" bg="gray.400" mx="1" cursor="pointer"></Box>)}
        </Flex>}
      {onRemove && <button className={style.remove} type="button" onClick={handleRemove}>
          <ICON_BY_NAME.closecircle width="15px" height="15px" />
        </button>}
    </Box>;
};